import { render, staticRenderFns } from "./CmgGroupOrderMenu.vue?vue&type=template&id=7b139074&scoped=true&lang=pug&"
import script from "./cmg-group-order-menu.ts?vue&type=script&lang=ts&"
export * from "./cmg-group-order-menu.ts?vue&type=script&lang=ts&"
import style0 from "./CmgGroupOrderMenu.vue?vue&type=style&index=0&id=7b139074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b139074",
  null
  
)

export default component.exports